import React, { useEffect, useRef, useState } from "react";
import { withNamespaces } from "react-i18next";
import exportFromJSON from "export-from-json";
import {
  Row,
  Col,
  Card,
  Label,
  CardBody,
  CardTitle,
  Container,
  Button,
  Progress,
  Spinner,
} from "reactstrap";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import Breadcrumb from "../../../../components/Common/Breadcrumb";
import BootstrapTable from "react-bootstrap-table-next";
import "../../../../../node_modules/react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import { postSubmitForm } from "../../../../helpers/forms_helper";
import showNotification from "../../../../helpers/show_notification";
import printDiv from "../../../../helpers/print_data";
import moment from "moment";
import { AvField, AvForm } from "availity-reactstrap-validation";

const COGSItemsDateRangeReport = (props) => {
  const { SearchBar } = Search;
  const [dateRange, setDateRange] = useState({
    from_date: moment().startOf("month").format("YYYY-MM-DD"),
    to_date: moment().format("YYYY-MM-DD"),
  });

  useEffect(() => {
    loadAllBranches();
  }, []);

  const [allOrders, setAllOrders] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [allBranches, setAllBranches] = useState([]);
  const [progress, setProgress] = useState(0);
  const BATCH_SIZE = 10;
  const CONCURRENCY = 2;
  const ordersRequestId = useRef(0);

  const loadAllBranches = async () => {
    try {
      let url = process.env.REACT_APP_BASEURL + "stores/getall";
      let response = await postSubmitForm(url, "");
      if (response.status === 1) {
        const res = response.data.filter(
          (store) =>
            store.type !== "EQUIPMENT STORE" && store.is_active === true,
        );
        // const res = response.data.filter((store) => (store.type === "CENTRAL STORE" || store.name === "ABUSAMRA"));
        // const res = response.data.filter((store) => (store.type === "CENTRAL STORE" | store.type === "Sub Store" || store.type === "Main Store")  && store.is_active === true)
        // const sorted =  res.sort((a, b) => a.name.localeCompare(b.name))
        setAllBranches(res);
      } else {
        showNotification(response.message, "Error");
      }
    } catch (error) {
      console.error(error);
    }
  };

  const loadOrders = async () => {
    const requestId = ++ordersRequestId.current;
    try {
      setIsLoading(true);
      setProgress(0);
      setAllOrders([]);

      const url =
        process.env.REACT_APP_BASEURL + "reports/cogs_items_daily_report";
      const mapBranches = (branches) =>
        (branches || []).map((branch) => ({
          ...branch,
          id: branch.id || branch._id,
        }));

      const branchIds = allBranches.map((branch) => branch._id);
      const batches = [];
      for (let i = 0; i < branchIds.length; i += BATCH_SIZE) {
        batches.push(branchIds.slice(i, i + BATCH_SIZE));
      }
      const totalBatches = batches.length || 1;
      let completed = 0;
      let nextIndex = 0;

      const runWorker = async () => {
        while (nextIndex < batches.length) {
          if (requestId !== ordersRequestId.current) return;
          const index = nextIndex++;
          const payload = {
            date_from: dateRange?.from_date,
            date_to: dateRange?.to_date,
            branch_ids: batches[index],
          };
          try {
            const batchResponse = await postSubmitForm(url, payload);
            if (requestId !== ordersRequestId.current) return;
            if (batchResponse && batchResponse.status === 1) {
              const newBranchData = mapBranches(
                batchResponse.data.branches || [],
              );
              setAllOrders((prevOrders) => {
                const newBranchIds = new Set(
                  newBranchData.map((branch) => String(branch._id)),
                );
                const filteredPrevOrders = prevOrders.filter(
                  (order) => !newBranchIds.has(String(order._id)),
                );
                return [...filteredPrevOrders, ...newBranchData];
              });
            }
          } catch (batchError) {
            console.error(`Error processing batch ${index + 1}:`, batchError);
          } finally {
            completed += 1;
            setProgress(Math.round((completed / totalBatches) * 100));
          }
        }
      };

      const workers = Math.min(CONCURRENCY, batches.length || 1);
      await Promise.all(Array.from({ length: workers }, () => runWorker()));
    } catch (error) {
      if (requestId !== ordersRequestId.current) return;
      console.error("Error loading orders:", error);
      showNotification("Error loading data", "Error");
    } finally {
      if (requestId === ordersRequestId.current) {
        setProgress(100);
        await new Promise((resolve) => setTimeout(resolve, 400));
        if (requestId === ordersRequestId.current) {
          setIsLoading(false);
        }
      }
    }
  };

  useEffect(() => {
    let isMounted = true;

    const fetchData = async () => {
      if (allBranches.length > 0) {
        setAllOrders([]);
        if (isMounted) {
          // await loadOrders();
        }
      }
    };

    fetchData();

    // Cleanup function
    return () => {
      isMounted = false;
    };
  }, [allBranches]);

  const calculateCOGS = (row) => {
    const cogs =
      Number(row.item_cost_opening ? row.item_cost_opening : 0) +
      Number(row.item_purchase_cost) +
      Number(row.supplier_return_credit_cost) +
      Number(row.item_inbound_transfer_cost) -
      Number(row.item_outbound_transfer_cost) -
      Number(row.item_cost);

    return isNaN(cogs) ? 0 : cogs;
  };

  const formatMoney = (value) => {
    const amount = Number(value);
    if (!Number.isFinite(amount)) return "0.00";
    return amount.toFixed(2);
  };

  const columns = [
    {
      dataField: "_id",
      hidden: true,
    },
    {
      dataField: "_id",
      formatter: (cell, row, rowIndex) => {
        return rowIndex + 1;
      },
      text: props.t("#"),
      headerStyle: (colum, colIndex) => {
        return { width: "4%" };
      },
    },
    {
      dataField: "name",
      text: props.t("Branch"),
      sort: true,
      formatter: (cell, row, rowIndex) => {
        return (
          <span className="mr-2">
            {row.name}{" "}
            <span
              hidden={!row.is_free}
              className="text-danger"
              style={{ fontSize: "20px" }}
            >
              *
            </span>
          </span>
        );
      },
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },
    {
      text: props.t("Opening"),
      dataField: "item_cost_opening",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "6%" };
      },
      formatter: (cell, row, rowIndex) => {
        return <span>{formatMoney(cell)}</span>;
      },
    },
    {
      dataField: "item_purchase_cost",
      text: props.t("Purchase"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "6%" };
      },
      formatter: (cell, row, rowIndex) => {
        return <span>{formatMoney(cell)}</span>;
      },
    },
    {
      dataField: "item_outbound_transfer_cost",
      text: props.t("Out Trans"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "6%" };
      },
      formatter: (cell, row, rowIndex) => {
        return <span>{formatMoney(cell)}</span>;
      },
    },
    {
      dataField: "item_inbound_transfer_cost",
      text: props.t("In Trans"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "6%" };
      },
      formatter: (cell, row, rowIndex) => {
        return <span>{formatMoney(cell)}</span>;
      },
    },
    {
      text: props.t("Closing"),
      dataField: "item_cost",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "6%" };
      },
      formatter: (cell, row) => {
        return <span>{formatMoney(cell)}</span>;
      },
    },
    {
      text: props.t("COGS"),
      dataField: "cogs",
      sort: true,
      sortFunc: (a, b, order, dataField, rowA, rowB) => {
        const cogsA = calculateCOGS(rowA);
        const cogsB = calculateCOGS(rowB);

        if (order === "asc") {
          return cogsA - cogsB;
        }
        return cogsB - cogsA;
      },
      headerStyle: (colum, colIndex) => {
        return { width: "6%" };
      },
      formatter: (cell, row) => {
        return formatMoney(calculateCOGS(row));
      },
    },
    {
      text: props.t("Used"),
      dataField: "used_item_cost",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "6%" };
      },
      formatter: (cell, row) => {
        return <span>{formatMoney(cell)}</span>;
      },
    },
    {
      text: props.t("Waste"),
      dataField: "waste_item_cost",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
      formatter: (cell, row) => {
        return <span>{formatMoney(cell)}</span>;
      },
    },
    {
      text: props.t("Discard"),
      dataField: "discard_item_cost",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "6%" };
      },
      formatter: (cell, row) => {
        return <span>{formatMoney(cell)}</span>;
      },
    },
    {
      text: props.t("Central Return"),
      dataField: "supplier_return_credit_cost",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
      formatter: (cell) => {
        return <span>{formatMoney(cell)}</span>;
      },
    },
    {
      text: props.t("Supplier Return"),
      dataField: "supplier_return_debit_cost",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
      formatter: (cell) => {
        return <span>{formatMoney(cell)}</span>;
      },
    },
    {
      dataField: "free_items_cost",
      text: props.t("Used Free"),
      sort: true,
      headerStyle: { width: "5%" },
      formatter: (cell, row, rowIndex) => {
        return <span>{formatMoney(cell)}</span>;
      },
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
    },
  ];

  const handleDownload = async () => {
    const fileName = `cogs_report_items`;
    const exportType = "xls";

    let data_to_export = allOrders;

    if (data_to_export) {
      var data = [];
      JSON.parse(JSON.stringify(data_to_export)).forEach(function (v) {
        data.push({
          Branch: v.name,
          "Opening Cost": formatMoney(v.item_cost_opening),
          "Purchase Cost": formatMoney(v.item_purchase_cost),
          "Outbound Transfer": formatMoney(v.item_outbound_transfer_cost),
          "Inbound Transfer": formatMoney(v.item_inbound_transfer_cost),
          "Closing Cost": formatMoney(v.item_cost),
          COGS: formatMoney(calculateCOGS(v)),
          Used: formatMoney(v.used_item_cost),
          Waste: formatMoney(v.waste_item_cost),
          Discard: formatMoney(v.discard_item_cost),
          "Central Return Credit": formatMoney(v.supplier_return_credit_cost),
          "Return Debit": formatMoney(v.supplier_return_debit_cost),
          "Free Cost": formatMoney(v.free_items_cost),
        });
      });

      exportFromJSON({ data, fileName, exportType });
    }
  };

  const FormulaExplanation = ({ t }) => (
    <div className="bg-light p-2 mb-4 rounded">
      <h6 className="font-weight-bold mb-3">{t("Formula Explanations")}:</h6>
      <div className="row">
        <div className="col-md-8">
          <p className="mb-2">
            <span className="font-weight-bold">COGS</span> = Opening + Purchase
            + Central Return + Inbound Transfer - Outbound Transfer - Closing
          </p>
        </div>
        <div className="col-md-4">
          <p className="mb-2">
            <span className="font-weight-bold">Inventory Deductions</span> =
            Used + Waste + Discard + Supplier Return
          </p>
        </div>
        {/* <div className="col-12">
          <p className="mb-0">
            <span className="font-weight-bold">Difference</span> = |COGS - Used Total|
            <small className="text-muted ml-2">(Absolute difference between COGS and Used Total)</small>
          </p>
        </div> */}
      </div>
    </div>
  );
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumb
            alternateTitle={props.t("COGS Items - Date Range")}
            title={props.t("COGS Items Reports")}
            breadcrumbItem={props.t("COGS Items - Date Range")}
          />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <AvForm>
                    <Row>
                      <Col lg={2} sm={2}>
                        <AvField
                          name="from_date"
                          label={props.t("From Date")}
                          placeholder={props.t("Select")}
                          type="date"
                          value={dateRange?.from_date}
                          onChange={(e) => {
                            const selectedDate = e.target.value;

                            const maxDate = moment(selectedDate)
                              .add(30, "days")
                              .format("YYYY-MM-DD");
                            const currentDate = moment().format("YYYY-MM-DD");

                            setDateRange((prev) => ({
                              ...prev,
                              from_date:
                                moment(selectedDate).format("YYYY-MM-DD"),
                              to_date:
                                moment(prev.to_date).isAfter(maxDate) ||
                                moment(prev.to_date).isAfter(currentDate)
                                  ? maxDate > currentDate
                                    ? currentDate
                                    : maxDate
                                  : prev.to_date,
                            }));
                          }}
                          max={moment().format("YYYY-MM-DD")}
                          errorMessage={props.t("Date cannot be empty.")}
                          validate={{ required: { value: true } }}
                        />
                      </Col>

                      <Col lg={2} sm={2}>
                        <AvField
                          name="to_date"
                          label={props.t("To Date")}
                          placeholder={props.t("Select")}
                          type="date"
                          value={dateRange?.to_date}
                          onChange={(e) => {
                            const selectedDate = e.target.value;
                            setDateRange((prev) => ({
                              ...prev,
                              to_date:
                                moment(selectedDate).format("YYYY-MM-DD"),
                            }));
                          }}
                          min={dateRange.from_date}
                          max={
                            moment(dateRange.from_date)
                              .add(30, "days")
                              .format("YYYY-MM-DD") >
                            moment().format("YYYY-MM-DD")
                              ? moment().format("YYYY-MM-DD")
                              : moment(dateRange.from_date)
                                  .add(30, "days")
                                  .format("YYYY-MM-DD")
                          }
                          errorMessage={props.t("Date cannot be empty.")}
                          validate={{ required: { value: true } }}
                        />
                      </Col>

                      <Col lg={3} sm={3}>
                        <Label></Label>
                        <Button
                          type="submit"
                          className="btn btn-md btn-success mt-4"
                          onClick={() => {
                            if (dateRange?.from_date && dateRange?.to_date) {
                              loadOrders();
                            }
                          }}
                        >
                          <i className="mdi mdi-checkbox-marked-circle"></i>{" "}
                          {props.t("Check")}
                        </Button>
                      </Col>
                      <Col lg={5} sm={5} className="text-right mt-4">
                        <Button
                          type="submit"
                          className="btn btn-sm btn-secondary"
                          onClick={handleDownload}
                        >
                          <i className="mdi mdi-file-export"></i>{" "}
                          {props.t("Export CSV")}
                        </Button>
                        {"   "}
                        <Link
                          to="#"
                          onClick={() => {
                            printDiv("printDiv");
                          }}
                          className="btn btn-sm btn-success mr-2"
                        >
                          <i className="fa fa-print"></i> Print
                        </Link>
                      </Col>
                    </Row>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  {isLoading && (
                    <div className="mb-3">
                      <Progress
                        animated
                        color="info"
                        value={progress}
                        style={{
                          height: "20px",
                          color: "Highlight",
                          fontWeight: "bold",
                        }}
                      >
                        {Math.round(progress)}% Loading...
                      </Progress>
                    </div>
                  )}
                  <div id="printDiv">
                    <CardTitle className="text-center">
                      {props.t("Cost Of Goods Sold Report (Items)")}
                      <br />
                      {/* <h6>
                        (cogs = opening cost + purchase cost + inbound transfer
                        cost - outbound transfer cost - closing cost)
                      </h6> */}
                    </CardTitle>
                    <FormulaExplanation t={props.t} />
                    <ToolkitProvider
                      keyField="_id"
                      data={allOrders && allOrders}
                      columns={columns}
                      noDataIndication={props.t("No data to display.")}
                      bootstrap4
                      search
                    >
                      {(props) => (
                        <div>
                          <Row>
                            <Col lg={4}>
                              <SearchBar
                                {...props.searchProps}
                                style={{ width: "300px" }}
                              />
                            </Col>
                            <Col lg={4}></Col>
                            <Col lg={4}></Col>
                          </Row>
                          <BootstrapTable
                            striped
                            hover
                            noDataIndication={
                              isLoading ? (
                                <Spinner size={"md"} />
                              ) : (
                                "No data to display."
                              )
                            }
                            condensed
                            {...props.baseProps}
                          />
                        </div>
                      )}
                    </ToolkitProvider>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};
const mapStatetoProps = (state) => {};
export default withRouter(
  connect(mapStatetoProps, {})(withNamespaces()(COGSItemsDateRangeReport)),
);
